<template>
    <div class="vertical grow gallery-container" style="width: 35vw; height: 100%">
        <div style="margin-top: 20px;">
            <div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('FarmName') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <select v-model="selectedObject.farmId" :disabled="existingObject != null">
                                <option v-for="f in farms" :key="f.id" :value="f.id">
                                    {{f.name}}
                                </option>
                            </select>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('MainAssignee') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <select v-model="selectedObject.mainAssigneeId" >
                                <option v-for="n in names" :key="n.id" :value="n.id">
                                    {{n.name}}
                                </option>
                            </select>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('Description') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <textarea v-model="selectedObject.description" type="text" :placeholder="$t('Description')"/>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('DateFrom') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <date-picker :confirm="false" v-model="selectedObject.dateFrom" :type="'date'" :clearable="false" :format="'DD-MM-YYYY'"></date-picker>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('DateTo') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <date-picker :confirm="false" v-model="selectedObject.dateTo" :type="'date'" :clearable="false" :format="'DD-MM-YYYY'"></date-picker>
                        </td>
                    </tr>
                </div>
                <div style="justify-content: center; margin-bottom: 10px;" class="horizontal">
                    <div class="error" v-if="error != ''">{{ error }}</div>
                </div>
            </div>
        </div>
        <div style="align-self: center; margin-bottom: 20px;">
            <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="save"></Button>
        </div>
    </div>
</template>

<script>
import { getFarms, getAllUsersNames, saveVisit, editVisit } from '../../api/api';
import DatePicker from 'vue2-datepicker';
import Button from '../Button.vue';
import moment from 'moment';

export default {
    props: {
        existingObject: {
            type: Object,
            required: false,
            default: null
        }
    },
    components: {
        DatePicker,
        Button
    },
    data() {
        return {
            selectedObject: {
                farmId: '',
                dateFrom: null,
                dateTo: null,
                description: '',
                mainAssigneeId: ''
            },
            error: '',
            farms: [],
            names: [],
            photos: [],
            activePhotoIndex: 0
        }
    },
    methods: {
        async getData() {
            var result = await getFarms()
            this.farms = result.filter(x => x.name != '' && x.name != null)
            this.farms = this.farms.sort(this.sortSystemsByName)

            var namesResults = await getAllUsersNames()
            this.names = namesResults.sort(this.sortSystemsByName)

            if(this.existingObject != null) {
                this.selectedObject = Object.assign({}, this.existingObject)
                this.selectedObject.dateFrom = new Date(this.selectedObject.dateFrom)
                this.selectedObject.dateTo = new Date(this.selectedObject.dateTo)
            }
        },
        async save() {
            this.checkDataCorrectness()

            if(this.error != "") {
                return;
            }

            var toSend = Object.assign({}, this.selectedObject)
            toSend.dateFrom = moment(toSend.dateFrom).format('YYYY-MM-DD')
            toSend.dateTo = moment(toSend.dateTo).format('YYYY-MM-DD')
            if (this.existingObject == null) {
                await saveVisit(toSend)
            } else {
                await editVisit(toSend)
            }
            this.$emit('saved')
        },
        checkDataCorrectness() {
            this.error = ""

            if(!this.farms.map(x => x.id).includes(this.selectedObject.farmId)) {
                this.error = "Select Farm before saving."
                return;
            }

            if(!this.names.map(x => x.id).includes(this.selectedObject.mainAssigneeId)) {
                this.error = "Select Main Assignee."
                return;
            }

            if(this.selectedObject.description == null) {
                this.selectedObject.description = ''
            }

            if(this.selectedObject.dateFrom == null) {
                this.error = "Select Date From."
                return;
            }

            if(this.selectedObject.dateTo == null) {
                this.error = "Select Date To."
                return;
            }
        },
        sortSystemsByName(a, b){
			return (a.name.localeCompare(b.name, undefined, {
              numeric: true,
              sensitivity: 'base'
            }));
		},
    },
    async mounted() {
        this.getData()
    }
}
</script>

<style scoped>
.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.section-title {
    font-weight: bold;
    text-align: center;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
    justify-content: center;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    align-self: center;
    width: 80%;
    margin: 0;
    padding-bottom: 5px;
}

.section-title {
    font-weight: bold;
}

select {
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

textarea {
    height: 200px;
    max-height: 300px;
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

.error {
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Visits/VisitModal.vue